var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mt-5",attrs:{"block":"","max-height":"36px","to":_vm.resultsTarget()}},[_c('v-icon',[_vm._v("mdi-chevron-double-left")]),_vm._v(" "+_vm._s(_vm.$t('back-button'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }